import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { IntegrationObjectService } from '../api/integration-object-service';
import type { IntegrationObjectsMetaPage } from '../types/integration-meta';

/** One request covers the catalogue for every integration we have seen; the cap is the API's. */
const CATALOGUE_PAGE_SIZE = 1000;

export const integrationObjectsMetaQueryKeys = {
  all: ['integration-objects-meta'] as const,
  byIntegration: (accountId: string, origin: string) =>
    ['integration-objects-meta', accountId, origin] as const,
};

export function useIntegrationObjectsMeta(
  accountId: string,
  origin: string,
): UseQueryResult<IntegrationObjectsMetaPage> {
  return useQuery({
    queryKey: integrationObjectsMetaQueryKeys.byIntegration(accountId, origin),
    queryFn: () =>
      IntegrationObjectService.getIntegrationObjectsMeta(accountId, origin, {
        pageSize: CATALOGUE_PAGE_SIZE,
      }),
    enabled: Boolean(accountId && origin),
  });
}
